import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import i18n from "../../i18n/i18n";
import type { IDisplayField } from "../../interfaces/interfaces";
import "./OuterData.css";


export const OuterData = ({ inputs, errors, translationNamespace, wellId }: { inputs: IDisplayField[], errors: string[], translationNamespace: string, wellId?: "well1" | "well2" }) => {
	const { t } = useTranslation(translationNamespace);
	const [expanded, setExpanded] = useState(false);

	if (!inputs) return null;
	const hasError = inputs.some(input => input.error) || errors.length > 0;

	return (
		<fieldset className={`outer-data-container round-corner-container ${hasError ? "error" : ""}`}>
			<legend className={`${hasError ? "error" : ""}`}>
				<button
					type="button"
					className="outer-data-toggle"
					aria-expanded={expanded}
					onClick={() => setExpanded(value => !value)}
				>
					<span aria-hidden="true">{expanded ? "-" : "+"}</span>
					<span>{t(`outer_data.${translationNamespace}`)} {wellId ? t(`outer_data.${wellId}`) : ""}</span>
				</button>
			</legend>
			{expanded && (
				<>
					{inputs.map(input => (
						<div className={`outer-data-row ${input.error ? "error" : ""}`} key={input.id}>
							<span style={{ display: 'inline-block', minWidth: '40px' }}>
								<Trans
									ns={translationNamespace}
									i18nKey={input.translationKey}
									components={{
										sub: <sub />,
										sup: <sup />,
									}}
								/>:
							</span>
							{input.displayValue ?? "__"}
							{input.currentUnitId &&
								<Trans
									key={i18n.language}
									i18nKey={`measurement_units.${input.unitCategoryId}.${input.currentUnitId}`}
									components={{
										sub: <sub />,
										sup: <sup />,
									}}
								/>
							}
						</div>
					))}
					{errors.map((error, index) => (
						<div className="error" key={index}>{t(`validation.${error}`)}</div>
					))}
				</>
			)}
		</fieldset>
	);
};
